// src/store/features/billers/billerActions.ts
import { createAction } from "@reduxjs/toolkit";
import { Biller } from "./billerTypes";

export interface fetchBillersRequestPayload {
  page: number;
  limit: number;
  search?: string | null;
  region?: string;
  category: string;
}
export interface getBillerByCategoryPayload {
  category: string;
}

// fetch list
export const fetchBillersRequest = createAction<fetchBillersRequestPayload>(
  "billers/fetchRequest",
);
export const getBillerByCategoryRequest = createAction<{ category: string }>(
  "billers/getBillerByCategoryRequest",
);
export const fetchBillersSuccess = createAction<Biller[]>(
  "billers/fetchSuccess",
);
export const fetchBillersFailure = createAction<string>("billers/fetchFailure");

// select single biller
export const selectBiller = createAction<Biller>("billers/select");

// clear selected
export const clearSelectedBiller = createAction("billers/clearSelected");

// export const billerActions = { fetchBillersRequest, fetchBillersSuccess, fetchBillersFailure, selectBiller, clearSelectedBiller };
